import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator"; // HasOnSuccess is added in P21 change
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

export interface CheckoutCartParameter extends ApiParameter {
    cart: CartModel;
}

export interface CheckoutCartModel {
    cart: CartModel
}

type HandlerType = CustomApiHandler<{
    cart?: CartModel;
} & HasOnSuccess<CheckoutCartParameter>, CheckoutCartModel>; // Added a property on the basis of HasOnSuccess: P21 Change

export const DispatchLoadCheckoutCart: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/LoadCheckoutCart",
        result: props.parameter,
    });
};

export const DispatchCompleteCheckoutCart: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteCheckoutCart",
        cart: props.parameter.cart,
    });
};

// Below exported function/handler is a P21 Change
export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

// ExecuteOnSuccessCallback has been added in P21 Change
export const chain = [DispatchLoadCheckoutCart, DispatchCompleteCheckoutCart, ExecuteOnSuccessCallback];

const checkoutCart = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        cart: {} as CartModel,
        onSuccess: (result) => { }
    },
    "checkoutCart",
);
export default checkoutCart;
